import { AdminLink } from '@components/Header/components/AdminLink';
import { Avatar } from '@components/Header/components/Avatar';
import { NotificationsIcon } from '@components/Header/components/NotificationsIcon';
import { VsLogo } from '@components/Logo';
import { useInitContext } from '@providers/InitProvider';
import { Header } from './styles/Header';
import { Root } from './styles/Root';
import { TProps } from './types/TProps';

export const CleanLayout = ({ children }: TProps) => {
  const { isInitialized, isAuthenticated } = useInitContext();
  return (
    <Root>
      <Header>
        <VsLogo />

        {isInitialized && isAuthenticated ? (
          <div className="right-side">
            <NotificationsIcon />
            <AdminLink />
            <Avatar />
          </div>
        ) : null}
      </Header>
      {children}
    </Root>
  );
};
